// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"80":"edca5fab","113":"ee1e8a36","170":"8dddc24d","292":"64de8a7b","315":"a1e140a9","319":"28100035","338":"644511f2","418":"90e97a60","584":"d4cc378e","641":"70773885","645":"4de44554","668":"01b618d3","720":"04baa959","728":"f312cb76"}[chunkId] + ".chunk.js";
};